import { AppRoutes } from '../../types/constants.types';

export const WEBSITE_CMS_ALLOWED_EMAIL = 'qr0003@mailinator.com';

export const WEBSITE_CMS_EXTERNAL_URL = 'https://e2g.food/admin';

export const WEBSITE_CMS_RESTRICTED_PATHS = [
  AppRoutes.CMS,
  WEBSITE_CMS_EXTERNAL_URL,
];

export function normalizeEmail(email: string | undefined | null): string {
  return (email || '').trim().toLowerCase();
}

export function canAccessWebsiteCms(email: string | undefined | null): boolean {
  return normalizeEmail(email) === WEBSITE_CMS_ALLOWED_EMAIL;
}

export function isWebsiteCmsRestrictedPath(path: string): boolean {
  return WEBSITE_CMS_RESTRICTED_PATHS.includes(path);
}
